import { User } from "./../../views/member/user";
import { Manager } from "../../views/member/manager";
import { Role } from "../../views/member/role";
import { Privilege } from "../../views/member/privilege";


import { langPage } from "../../locales";

const lang = langPage?.member;

export const memberRouters = [
    {
        path: "/member/user",
        name: "user",
        exact: true,
        component: User,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.user.name,
                    path: ""
                },
            ],
            privilegeCode: "user",
        }
    },
    {
        path: "/member/manager",
        name: "manager",
        exact: true,
        component: Manager,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.manager.name,
                    path: ""
                },
            ],
            privilegeCode: "manager",
        }
    },
    {
        path: "/member/role",
        name: "role",
        exact: true,
        component: Role,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.role.name,
                    path: ""
                },
            ],
            privilegeCode: "role",
        }
    },
    {
        path: "/member/privilege",
        name: "privilege",
        exact: true,
        component: Privilege,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: '权限管理',
                }
            ],
            privilegeCode: "privilege",
        }
    },
];



